import qs from "qs";
import authAxios, { authHeader } from "./data";

const generateEmailLetterReport = async (
  templateId: string,
  contractId: string
) => {
  const result = await authAxios.post(
    `/api/ReportGeneration/EmailLetterReport/${templateId}`,
    { contractId },
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const generateReceiptReportByName = async (name: string, batchId: string) => {
  const result = await authAxios.post(
    `/api/ReportGeneration/${name}/print`,
    null,
    {
      headers: authHeader(),
      params: { batchId },
    }
  );

  return result.data;
};

const generateReportByName = async (name: string, request: any) => {
  const result = await authAxios.post(
    `/api/ReportGeneration/${name}`,
    request,
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const exportByName = async (name: string, request: any) => {
  const response = await authAxios.get(`/api/Export/${name}`, {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
    responseType: "blob",
  });

  return response.data;
};

const exportBulk1098 = async () => {
  const response = await authAxios.get(`/api/Export/BulkTax1098`, {
    params: {},
    headers: authHeader(),
  });

  return response.data;
};

const download = async (id: string) => {
  const response = await authAxios.get(`/api/ReportGeneration/${id}/Download`, {
    headers: authHeader(),
    responseType: "blob",
  });
  return response.data;
};

const ReportService = {
  generateEmailLetterReport,
  generateReceiptReportByName,
  generateReportByName,
  exportByName,
  exportBulk1098,
  download,
};

export default ReportService;
